import { gql } from '@apollo/client/core';

export const TYPE_FIELDS = gql`
  fragment TypeFields on Type {
    id
    name
  }
`;

export const CATEGORY_FIELDS = gql`
  fragment CategoryFields on Category {
    id
    name
  }
`;

export const SUBCATEGORY_FIELDS = gql`
  fragment SubcategoryFields on Subcategory {
    id
    categoryId
    name
  }
`;
